import {
  PRODUCTS_ACCESS_CONTROL_REPORTS,
  PRODUCTS_REPORTS,
  ROLE_PRODUCT_VIEWER,
  ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT,
  ROUTE_ACCESS_CONTROL_REPORT_BY_JIRA_PROJECT,
  ROUTE_ACCESS_CONTROL_REPORT_BY_USER,
  ROUTE_PRODUCTS_LIST,
  ROUTE_PRODUCT_SPOTLIGHT_SUMMARY_REPORT,
} from "../../SharedModule/utils/constants";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import { useSelector } from "react-redux";
import { actualUIState } from "../../SharedModule/redux/reducers/uiShared.reducer";

export const LeftNavBarProducts = (props: any) => {
  const { userRolesProductsModule } = useSelector(actualUIState);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Products"
        biIconName="BiCube"
        requireModuleAccess={true}
        roleRequired={[ROLE_PRODUCT_VIEWER]}
        actualUserRoles={userRolesProductsModule}
        listOfLinks={[
          {
            text: "Product List",
            route: ROUTE_PRODUCTS_LIST,
            requireModuleAccess: true,
            roleRequired: [ROLE_PRODUCT_VIEWER],
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={true}
        roleRequired={PRODUCTS_REPORTS}
        actualUserRoles={userRolesProductsModule}
        listOfLinks={[
          {
            text: "Spotlight Summary",
            route: ROUTE_PRODUCT_SPOTLIGHT_SUMMARY_REPORT,
            requireModuleAccess: true,
            roleRequired: PRODUCTS_REPORTS,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Access Control Report"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={true}
        roleRequired={PRODUCTS_ACCESS_CONTROL_REPORTS}
        actualUserRoles={userRolesProductsModule}
        listOfLinks={[
          {
            text: "By User",
            route: ROUTE_ACCESS_CONTROL_REPORT_BY_USER,
            requireModuleAccess: true,
            roleRequired: PRODUCTS_ACCESS_CONTROL_REPORTS,
          },
          {
            text: "By Jira Project",
            route: ROUTE_ACCESS_CONTROL_REPORT_BY_JIRA_PROJECT,
            requireModuleAccess: true,
            roleRequired: PRODUCTS_ACCESS_CONTROL_REPORTS,
          },
          {
            text: "By Gitlab Project",
            route: ROUTE_ACCESS_CONTROL_REPORT_BY_GITLAB_PROJECT,
            requireModuleAccess: true,
            roleRequired: PRODUCTS_ACCESS_CONTROL_REPORTS,
          },
        ]}
      />
    </LeftNavBar>
  );
};
